import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SIZES, APPEARANCES, TYPES, ALIGN } from './constants';

const getTagByType = (type) => {
  const tags = {
    [TYPES.paragraph]: 'p',
    [TYPES.listItem]: 'li',
    [TYPES.link]: 'a',
    [TYPES.label]: 'label',
    [TYPES.mark]: 'span',
    [TYPES.heading]: 'div',
  };

  return tags[type];
};

const Text = ({
  appearance = APPEARANCES.highEmphasis,
  children,
  className = '',
  size = SIZES.medium,
  type = TYPES.paragraph,
  align = ALIGN.left,
  isUnderlined = false,
  isClipped = false,
  linkConfig = null,
  labelConfig = null,
  onClick = Function.prototype,
}) => {
  const isTypeLink = type === TYPES.link && linkConfig;
  const isTypeLabel = type === TYPES.label && labelConfig;

  const classes = classNames(
    'ws-ui-text',
    `ws-ui-text--${size}`,
    `ws-ui-text--${appearance}`,
    `ws-ui-text--align-${align}`,
    `ws-ui-text--${type}`,
    className,
    {
      'ws-ui-text--underline': isUnderlined,
      'ws-ui-text--ellipsis': isClipped,
    }
  );

  const linkAttributes = isTypeLink
    ? {
        href: linkConfig.href,
        rel: 'noreferrer',
        ...(linkConfig.target && { target: linkConfig.target }),
      }
    : {};

  const labelAttributes = isTypeLabel
    ? {
        for: labelConfig.for,
      }
    : {};

  const Tag = getTagByType(type);

  return (
    <Tag className={classes} {...linkAttributes} {...labelAttributes} onClick={onClick}>
      {children}
    </Tag>
  );
};

Text.propTypes = {
  appearance: PropTypes.oneOf(Object.values(APPEARANCES)),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf(Object.values(SIZES)),
  type: PropTypes.oneOf(Object.values(TYPES)),
  align: PropTypes.oneOf(Object.values(ALIGN)),
  isUnderlined: PropTypes.bool,
  isClipped: PropTypes.bool,
  linkConfig: PropTypes.shape({
    href: PropTypes.string.isRequired,
    target: PropTypes.string,
  }),
  labelConfig: PropTypes.shape({
    for: PropTypes.string.isRequired,
  }),
  onClick: PropTypes.func,
};

export default Text;
